import { IncomingHttpHeaders, IncomingMessage } from 'http';
import { NextRequest } from 'next/server';
import { getPlatformBySource, getSourceFromUA } from './getSSRPlatform';

export const getSSRContextData = (
  req?: (IncomingMessage & { headers?: IncomingHttpHeaders }) | NextRequest
) => {
  /**
   * Universal header getter that handles both Node.js IncomingMessage (object)
   * and Web Standard NextRequest (Headers map).
   */
  const getHeader = (name: string): string => {
    if (!req?.headers) return '';

    type UniversalHeaders = Record<string, string> & {
      get?: (name: string) => string | null;
    };
    const headers = req.headers as UniversalHeaders;

    // NextRequest/Middleware use the Fetch API Headers object with a .get() method
    if (typeof headers.get === 'function') {
      return headers.get(name) || '';
    }

    // Traditional SSR (getServerSideProps) uses a plain object for headers
    return headers[name] || '';
  };

  const userAgent = getHeader('user-agent');
  const cookie = getHeader('cookie');

  const source = getSourceFromUA(userAgent);
  const isSSRWebView = userAgent.indexOf('miniApp') >= 0;
  const platform = getPlatformBySource(source, isSSRWebView);

  return {
    userAgent,
    cookie,
    source,
    isSSRWebView,
    platform
  };
};
